import homeState from '@/entity/module/home/home';
import apiHttpHelper, { ResponseBasic } from '@/common/ApiHelper';
import homeApi from '@/entity/module/home/homeAPi';
import { dispatchProps } from '@/entity';
import { TLang } from '@/utils/lang';

const sortArr = [
  {
    value: 1,
    label: TLang('综合排序', 'home', false, false, null)
  },
  {
    value: 2,
    label: TLang('离我最近', 'home', false, false, null)
  },
  {
    value: 3,
    label: TLang('价格最低', 'home', false, false, null)
  }
];
export default {
  namespace: 'home', // 表示在全局 state 上的 key
  state: { districtBusinessData: [], sortData: [], leftBarObj: [], rightBarObj: [] }, // 状态数据
  // 管理同步方法，必须是纯函数
  reducers: {
    SetDistrictData(state: homeState, { payload }: dispatchProps) {
      const { businessDistrict = [], district = [] } = payload;
      // 转换的菜单数据
      // console.log('payload---',payload)
      const menuData = district&&district.map((districtItem) => {
        const oriBusData = businessDistrict.filter((busItem) => busItem.districtId === districtItem.id);
        const busData = oriBusData.map((busI) => ({
          label: busI.name,
          value: busI.id,
          cinemaCount: busI.cinemaCount,
          districtId: busI.districtId
        }));
        return { label: districtItem.name, value: districtItem.id, cinemaCount: districtItem.cinemaCount, children: busData };
      });
      const nLeftBarObj = menuData && menuData.length > 0 ? menuData[0] : menuData;
      return {
        ...state,
        districtBusinessData: menuData,
        leftBarObj: state.leftBarObj ?? nLeftBarObj,
        rightBarObj: state.rightBarObj ?? sortArr[1],
        sortData: sortArr
      };
    },
    SetMenuBarObj(state: homeState, { payload }: dispatchProps) {
      if (payload.type === 3) {
        return {
          ...state,
          leftBarObj: null,
          rightBarObj: null
        };
      } else if (payload.type === 1) {
        return {
          ...state,
          leftBarObj: payload.data
        };
      } else {
        return {
          ...state,
          rightBarObj: payload.data
        };
      }
    }
  },
  // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Generator
  // 管理异步操作，采用了 generator 的相关概念
  effects: {
    *GetDistrictDate({ payload }, { call, put, select }) {
      // 获取 state 中的值
      // const { title } = yield select(state => { state.movie });
      // 接口入参
      // const params = { ...payload };
      const data = yield call(homeApi.GetDistrictData);
      // console.log('data',data);
      // if(data.Status===0){
      // 请求成功之后，调用 reducer 同步方法更新 state
      if (!data) return;
      yield put({
        // 调用当前 model 的 action 不需要添加 namespace
        type: 'SetDistrictData',
        payload: data
      });
      // }
    }
  },
  subscriptions: {} // 订阅数据源
};
